import { fetcherReactQuery } from '../../services/api/fetcher'
import { useQuery } from 'react-query'

const fetch = async (api) => {
    const response = await fetcherReactQuery(api)
    return response.data
}
const useLoanHistory = (userId) => {
    return useQuery([`/api/GetHistorialPrestamos/${userId}`], fetch);
}

export default useLoanHistory






